import { FC } from "react";
import cn from "classnames";

import Paragraph from "../../components/Typography/Paragraph";
import BackButton from "../BackButton/BackButton";

import { Props } from "./ActionBar.props";
import styles from "./ActionBar.module.scss";

export const ActionBar: FC<Props> = ({ className, children, drugName, testId }: Props) => {
  const actionBarWrapper = cn(styles["ActionBarWrapper"], className);

  const MobileBackText = () => {
    return <Paragraph className={styles.BackTextMobile}>{drugName}</Paragraph>;
  };

  return (
    <div className={actionBarWrapper} data-testid={testId}>
      <BackButton classNames={styles.BackButton}>
        <MobileBackText />
      </BackButton>
      {children}
    </div>
  );
};
